import { ClaimRewardsModalBody } from "#/shared/components/modals/ClaimRewards"
import { ComponentStepProps } from "#/ui/Modal"

export default function RewardsClaimed({
  onClose,
  onClickContinue,
  onClickBack,
}: ComponentStepProps) {
  // TODO: Fetch points or pass as a props.
  const points = "3000"

  return (
    <ClaimRewardsModalBody
      hasClaimed
      onClose={onClose}
      onClickBack={onClickBack}
      totalMats={points}
      onClickContinue={onClickContinue}
    />
  )
}
